/*
 * @Author: Christion.Young
 * @Date: 2025-08-14 10:00:00
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: 工具类统一导出文件
 */

// 通用工具函数
export * from "./common";

// 图片处理工具
export { getImageUrl } from "./imageUtils";

// 消息提示工具
export { default as MessageUtil, MESSAGE_TYPES } from "./message";

// 权限相关工具
export {
  loginRequired,
  permissionMixin,
  install as installPermission,
} from "./permission";

// 加密解密工具
export { aesEncrypt, aesDecrypt } from "./crypto";

// HTTP 请求工具
export { get, post, put, delet, fileUpload, exportFile } from "./http";

// 事件总线工具
export { default as EventBus } from "./eventBus";

// Loading组件工具
export { default as LoadingUtil } from "../components/Common/Loading";

// 默认导出常用工具
export default {
  getImageUrl: require("./imageUtils").getImageUrl,
  MessageUtil: require("./message").default,
  permission: require("./permission"),
  EventBus: require("./eventBus").default,
  crypto: require("./crypto"),
  http: require("./http"),
  loading: require("../components/Common/Loading").default,
};
